export const rootCauseNames = {
	pricing: 'Pricing Change',
	pod: 'Points of Distribution',
	inventoryHealth: 'Replenishment Health',
	assortment: 'Assortment Change',
};